/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Select from 'react-select';
import useThemeContext from '../../../../contexts/theme';
import { CustomStyle } from '../../../CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../CustomSelectStyleDarkTheme';
import FilterRadioButton from '../../../FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../FilterRadioButtonsContainer';
import { SecondaryButton } from '../../../SecondaryButton';
import { WorkplaceType } from '../../types';
import { Container, SelectsContainer } from './styles';

interface FiltersInterface {
  workplacesOptions: WorkplaceType[];
  selectedWorkplace: WorkplaceType;
  selectedEmployee: { value: string, label: string };
  employeesOptions: { value: string, label: string }[];
  handleSelectedWorkplaceChange: (workplace: WorkplaceType) => void;
  handleSelectedEmployeeChange: (employee: { value: string, label: string }) => void;
  isSomeWorkplaceSelected: boolean;
  selectedColorView: 'criminalRisc' | 'optimizationStatus';
  setSelectedColorView: (colorView: 'criminalRisc' | 'optimizationStatus') => void;
  downloadDataAsKml: () => void;
}

export default function Filters({
  workplacesOptions,
  selectedWorkplace,
  selectedEmployee,
  employeesOptions,
  handleSelectedWorkplaceChange,
  handleSelectedEmployeeChange,
  isSomeWorkplaceSelected,
  selectedColorView,
  setSelectedColorView,
  downloadDataAsKml,
}: FiltersInterface) {
  const { selectedTheme } = useThemeContext();

  return (
    <Container>
      <SelectsContainer>
        <Select
          value={selectedWorkplace}
          options={workplacesOptions}
          onChange={(workplace) => {
            handleSelectedWorkplaceChange(workplace!);
          }}
          placeholder="Selecione um local de trabalho"
          styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
          // menuPortalTarget={document.body}
          classNamePrefix="react-select"
          className="react-select-container-as-filter"
        />

        {isSomeWorkplaceSelected && (
          <Select
            value={selectedEmployee}
            options={employeesOptions}
            onChange={(employee) => {
              handleSelectedEmployeeChange(employee!);
            }}
            placeholder="Selecione um funcionário"
            styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
            // menuPortalTarget={document.body}
            classNamePrefix="react-select"
            className="react-select-container-as-filter"
          />
        )}
      </SelectsContainer>

      <FilterRadioButtonsContainer>
        <FilterRadioButton selected={selectedColorView === 'optimizationStatus'} onClick={() => setSelectedColorView('optimizationStatus')}>
        Cores dos bonecos por status de otimização
        </FilterRadioButton>
        <FilterRadioButton selected={selectedColorView === 'criminalRisc'} onClick={() => setSelectedColorView('criminalRisc')}>
        Cores dos bonecos por risco de criminalidade
        </FilterRadioButton>
      </FilterRadioButtonsContainer>

      {selectedWorkplace.value && (
        <SecondaryButton onClick={downloadDataAsKml}>
            Download KML
        </SecondaryButton>
      )}
    </Container>
  );
}
